import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import moment from 'moment'

import Vuesax from 'vuesax'

import 'vuesax/dist/vuesax.css' //Vuesax styles
Vue.use(Vuesax)
import 'material-icons/iconfont/material-icons.css';

import {firebaseApp} from './fb'

import VueMask from 'v-mask'
Vue.use(VueMask);

import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

Vue.use(Datetime)

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

firebaseApp.auth().onAuthStateChanged(user =>{
  if(user){
    router.push('/')     
  }else{
    router.replace('/')
  }
})
Vue.prototype.moment = moment

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
